<template>
	<section class="w3l-contact-1 w3hny-form-btm py-5" id="contact">
		<div class="contacts-9 py-lg-5 py-md-4">
			<div class="container">
				<div class="header-sec text-center mb-5">
					<br />
					<h1 class="title-w3l">
						Success
					</h1>
				</div>
				<div class="contactct-fm map-content-9">
					<p>You have successfully created an account. Click the link in the verification email that has been
						sent to your email address.</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
useHead({
  //@ts-ignore
  title: `ForumLeadsFinder – Click on the verification link sent to you`,
  meta: [
    {
      name: "description",
      //@ts-ignore
      content: `ForumLeadsFinder - Verify ownership of your email address by clicking on the link sent to your email address.`
    }
  ]
});
</script>



<style scoped></style>